// extracted by mini-css-extract-plugin
export default {"cls1":"CreateComment-cls1__f9fcfa80c78ec8ac0f3d","cls2":"CreateComment-cls2___8185fef8138ac9e5bb1 CreateComment-cls1__f9fcfa80c78ec8ac0f3d"};